import { GetApproveTradesRequestPayload } from '@/pages/TransactionDetail/store/actions';
import { AxiosInstance } from 'axios';

import { GetTermSheetOutputTradesRequestPayload } from './../../pages/TransactionDetail/store/actions';

export default class TransactionsAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getTransactionTitleAndInfo(transactionId: number) {
    return this.client.post('/v2/hedging/transaction-info-and-title/', {
      transaction_id: transactionId,
    });
  }

  // Method for Transaction Detail
  async getNotionalSchedule(transactionId: number) {
    return this.client.post('/v2/hedging/transaction-notional-schedule/', {
      transaction_id: transactionId,
    });
  }

  async getTransactionValueDetails(transactionId: number) {
    return this.client.post('/v2/hedging/transaction-values-details/', {
      transaction_id: transactionId,
    });
  }

  async getTransactionCashflows(transactionId: number, cashflowDate: string) {
    return this.client.post('/v2/hedging/transaction-cashflows/', {
      transaction_id: transactionId,
      cashflow_date: cashflowDate,
    });
  }

  async downloadHistoricalTradeReport(transactionId: number) {
    return this.client.post(
      '/v2/reporting/download-historical-transaction-value-report/',
      {
        transaction_id: transactionId,
      },
    );
  }

  async getTransactionnBCVA(transactionId: number, cashflowDate: string) {
    return this.client.post('/v2/hedging/transaction-bilateral-cva/', {
      transaction_id: transactionId,
      cashflow_date: cashflowDate,
    });
  }

  async approveTrade(transactionIds: number[]) {
    return this.client.post('/v2/review/approvals/approve/', {
      transaction_ids: transactionIds,
      message: 'Trade Approved',
    });
  }

  async rejectTrade(payload: GetApproveTradesRequestPayload) {
    return this.client.post('/v2/review/approvals/reject/', payload);
  }

  async amendTrade(payload: GetApproveTradesRequestPayload) {
    return this.client.post('/v2/review/approvals/amend/', payload);
  }

  async downloadBCVAReport(transactionId: number, curveDate: string) {
    return this.client.post('/v2/reporting/download-bcva-report/', {
      transaction_id: transactionId,
      curve_date: curveDate,
    });
  }

  async downloadBCVAExposureReport(transactionId: number, curveDate: string) {
    return this.client.post(
      '/v2/hedge-accounting/download-bcva-exposure-report/',
      {
        transaction_id: transactionId,
        curve_date: curveDate,
      },
    );
  }

  async downloadXVAReport(
    transactionId: number,
    curveDate: string,
    cdsCurve: [] | null,
  ) {
    return this.client.post('/v2/reporting/download-xva-report/', {
      transaction_id: transactionId,
      xva_date: curveDate,
      cds_curve: cdsCurve,
    });
  }

  async getCDSCurveData(transactionId: number, cashFlowDate: string) {
    return this.client.post('/v2/hedging/transaction-cds-entity-curves/', {
      transaction_id: transactionId,
      cashflow_date: cashFlowDate,
    });
  }

  async getClosestValueDate(transactionId: number) {
    return this.client.get(
      `/v2/hedging/transaction/${transactionId}/closest-value-date`,
    );
  }

  async getActiveTransactionIdList() {
    return this.client.post('/v2/hedging/transactions/active/id-list/', {});
  }

  async getTradeDetails(transactionId: number) {
    return this.client.get(`/v2/hedging/transaction/${transactionId}/`);
  }

  async getTermSheetOutputTradesDetails(
    payload: GetTermSheetOutputTradesRequestPayload,
  ) {
    return this.client.post(
      '/v2/reporting/get-term-sheet-output-trades/',
      payload,
    );
  }
}
